import React from 'react'
import styles from '../index.module.scss'

const HEADLINE = 'Patients rate Thriveworks providers'
const RATING = '4.8 out of 5 stars'
const ATTRIBUTION = 'Patient NPS Scores'

const FooterValueProp: React.FC = () => {
  return (
    <div className={styles.value_prop} data-testid="footer-value-prop">
      <p className={styles.value_prop_headline}>{HEADLINE}</p>
      <div className={styles.value_prop_rating_row}>
        <span className={styles.value_prop_squiggle} aria-hidden="true" />
        <p className={styles.value_prop_rating}>{RATING}</p>
        <span
          className={`${styles.value_prop_squiggle} ${styles.value_prop_squiggle_mirror}`}
          aria-hidden="true"
        />
      </div>
      <p className={styles.value_prop_attribution}>{ATTRIBUTION}</p>
    </div>
  )
}

export default FooterValueProp
